import React from "react";
import { KTIcon } from "../../../../../_metronic/helpers";
import clsx from "clsx";

type Props = {
  className?: string;
  iconName?: string;
  iconClassName?: string;
  [key: string]: any;
};

function IconButton(props: Props) {
  const { className, btnText, iconName, iconClassName, ...rest } = props;
  return (
    <button
      type={"button"}
      className={clsx("button-blue ", className)}
      {...rest}
    >
      {iconName && <KTIcon iconName={iconName} className={iconClassName} />}
    </button>
  );
}

export default IconButton;
